// What a questionnaire card renders under the answer for its comment thread.
// A Documents-tab document's conversation lives in Documents (the vendor
// replies there, through DocumentThreadModal), so the questionnaire never
// shows that live thread or its composer. Once the document has a recorded
// approval its thread is partitioned (@l2u/shared/threadPartition): the card
// keeps the ORIGINAL review (messages before the first approval) read-only,
// and links to Documents when a newer conversation exists. Without a recorded
// approval: a link when the thread has messages, nothing otherwise. Every
// other answer keeps today's rule.

export type QuestionnaireThreadMode =
  | 'thread' // today's thread + composer (non-Documents-tab)
  | 'documents_link' // strip only
  | 'original_review' // read-only original + Approved line
  | 'original_review_with_link' // the above + strip below it
  | 'none';

/** What the card renders under the answer. A Documents-tab document never shows its live thread here: its original review (when partitioned) and/or a link to Documents, or nothing. */
export function questionnaireThreadMode(args: {
  inDocumentsTab: boolean;
  hasMessages: boolean;
  canReply: boolean;
  /** null = not partitioned (no recorded approval): PR #115's rule applies. */
  partition: { hasOriginal: boolean; hasCurrent: boolean } | null;
}): QuestionnaireThreadMode {
  if (args.inDocumentsTab && args.partition !== null) {
    const { hasOriginal, hasCurrent } = args.partition;
    if (hasOriginal && hasCurrent) return 'original_review_with_link';
    if (hasOriginal) return 'original_review';
    if (hasCurrent) return 'documents_link';
    return 'none';
  }
  if (args.inDocumentsTab) return args.hasMessages ? 'documents_link' : 'none';
  return args.hasMessages || args.canReply ? 'thread' : 'none';
}
